import { getCookieName } from '../../cookies/getCookieName';

export const LAQUESIS_COOKIE_NAMES = {
  LAQUESIS: getCookieName('laquesis'),
  LAQUESIS_FF: getCookieName('laquesisff'),
  LAQUESIS_QA: getCookieName('laquesisqa'),
};
